import { axiosInstance } from "services";

export const economicNexusApi = {
  getEconomicNexus: (body) => {
    return axiosInstance.post("/admin/economicNexus", body);
  },
  exportTaxFiling: (year, quarterId) => {
    return axiosInstance.get("/admin/economicNexus/export", {
      params: { year, quarterId, format: "csv" },
      responseType: "blob",
    });
  },
};
